module.exports = __webpack_public_path__ + "img/consultant_offer.f4326aff.png";